<!--
@create date 2023-6-26
@desc m08f.phomemo.com
-->
<template>
  <div class="guides-div">
    <div class="topText">
      <h1>Download for Phomemo M832 Portable Printer</h1>
    </div>
    <!--   <hr style="color: rgba(51, 61, 71,0.3);width: 30%;margin-bottom: 50px;" v-show="!isMobile()" /> -->
    <div class="main-contain">
      <!--     phone -->
      <div class="item-margin" v-show="isMobile()">
        <div style="margin-bottom: 40px">
          <img
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/app.png?v=1654666291"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a href="https://downloadapp.qu-in.life/MrIn-Phomemo/" class="a-link"
            >App for Smart Phone</a
          ><br />
        </div>
        <div class="video-contain">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            id="M832_APPVideo_2"
          >
            <source
              src="https://oss.qu-in.top/printerFiles/phomemo/M832/4.How to use on IOS Or Android.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <hr
          style="color: rgba(51, 61, 71, 0.3); margin-top: 40px"
          v-show="isMobile()"
        />
      </div>
      <!--     windows -->
      <div class="item-margin">
        <div style="margin-bottom: 12px">
          <img
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/windows-phone-logo-topic.png?v=1644832318"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a
            href="https://oss.qu-in.ltd/OfficialWebsite/Phomemo/QY_Printer%20Driver_WIN_EN.zip"
            class="a-link"
            @click="
              () => {
                refreshRecord({ key: 'M832_windowsDrivers' });
              }
            "
            >Driver for Windows</a
          >
        </div>
        <div class="video-contain">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            id="M832_windowsVideo"
          >
            <source
              src="https://oss.qu-in.top/printerFiles/phomemo/M832/1.How to use on Windows.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <hr
          style="color: rgba(51, 61, 71, 0.3); margin-top: 40px"
          v-show="isMobile()"
        />
        <hr
          style="color: rgba(51, 61, 71, 0.3)"
          v-show="!isMobile()"
          class="hrDivEx"
        />
      </div>

      <div class="item-margin">
        <div style="margin-bottom: 10px">
          <img
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/windows-phone-logo-topic.png?v=1644832318"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a
            href="https://oss.qu-in.ltd/OfficialWebsite/Phomemo/QY_Printer%C2%A0Driver_Windows_ARM.zip"
            class="a-link"
            style="line-height: 26px; font-size: 16px"
            @click="
              () => {
                refreshRecord({ key: 'M832_ARMDrivers' });
              }
            "
            >Driver for Windows(ARM)</a
          >
        </div>
        <div class="video-contain">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            id="M832_windowsVideo"
          >
            <source
              src="https://oss.qu-in.top/printerFiles/phomemo/M832/1.How to use on Windows.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <hr
          style="color: rgba(51, 61, 71, 0.3); margin-top: 40px"
          v-show="isMobile()"
        />
        <hr
          style="color: rgba(51, 61, 71, 0.3)"
          v-show="!isMobile()"
          class="hrDivEx"
        />
      </div>
      <!--     mac -->
      <div class="item-margin">
        <div style="margin-bottom: 16px">
          <img
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/2235.png?v=1644832141"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a
            href="https://oss.qu-in.ltd/OfficialWebsite/Phomemo/QY_Printer%20Driver_MAC_EN.zip"
            class="a-link"
            @click="
              () => {
                refreshRecord({ key: 'M832_macDrivers' });
              }
            "
            >Driver for Mac</a
          ><br />
        </div>
        <div class="video-contain">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 95%"
            id="M832_macVideo"
          >
            <source
              src="https://oss.qu-in.top/printerFiles/phomemo/M832/How_to_use_on_macOS.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <hr
          style="color: rgba(51, 61, 71, 0.3)"
          v-show="!isMobile()"
          class="hrDivEx"
        />
      </div>
      <!-- Linux -->
      <div class="item-margin">
        <div style="margin-bottom: 10px">
          <img
            src="https://pages.phomemo.com/resources/linuxIcon.png"
            style="
              display: block;
              margin: 10px auto;
              width: 100px;
              height: 110px;
            "
          />
          <a
            href="https://oss.qu-in.ltd/OfficialWebsite/Phomemo/QY_Printer%C2%A0Driver_Linux.gz"
            class="a-link"
            @click="
              () => {
                refreshRecord({ key: 'M832_linuxDrivers' });
              }
            "
            >Driver for Linux</a
          ><br />
        </div>
        <div class="video-contain">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 100%"
            id="M832_linuxVideo"
          >
            <source
              src="https://oss.qu-in.top/printerFiles/phomemo/M832/3.How to use on Linux.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <hr
          style="color: rgba(51, 61, 71, 0.3)"
          v-show="!isMobile()"
          class="hrDivEx"
        />
      </div>
      <!--     phone -->
      <div class="item-margin" v-show="!isMobile()">
        <div style="margin-bottom: 24px">
          <img
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/app.png?v=1654666291"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a
            href="https://downloadapp.qu-in.life/MrIn-Phomemo/"
            class="a-link"
            @click="
              () => {
                refreshRecord({ key: 'M832_AppStore' });
              }
            "
            >App for Smart Phone</a
          ><br />
        </div>
        <div class="video-contain">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            id="M832_APPVideo"
          >
            <source
              src="https://oss.qu-in.top/printerFiles/phomemo/M832/How_to_use_on IOSOrAndroid.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>
    </div>
    <hr
      style="color: rgba(51, 61, 71, 0.3); width: 54%; margin-bottom: 40px"
      v-show="!isMobile()"
    />
    <hr
      style="color: rgba(51, 61, 71, 0.3); width: 100%; margin-bottom: 40px"
      v-show="isMobile()"
    />
    <div class="customService" style="margin-top: 10px">
      <h1>Quick Start Guide</h1>
      <div>
        <a
          style="color: #1fc3ff; text-decoration: auto"
          href="https://doc.labelife.net/upload/video/phomemo/M832QuickStartGuide.pdf"
          target="_blank"
          @click="
            () => {
              refreshRecord({ key: 'M832_quickStartGuide' });
            }
          "
          >Click Here for A Quick Start Guide</a
        >
      </div>
    </div>
    <hr
      style="
        color: rgba(51, 61, 71, 0.3);
        width: 54%;
        margin: 45px auto;
        margin-top: 25px;
      "
      v-show="!isMobile()"
    />
    <hr
      style="
        color: rgba(51, 61, 71, 0.3);
        width: 100%;
        margin: 45px auto;
        margin-top: 25px;
      "
      v-show="isMobile()"
    />
    <div class="faq-content-area">
      <h1 style="margin-bottom: 33px; margin-top: 30px; text-align: center">
        Frequently Asked Questions
      </h1>
      <div class="faq-container">
        <div
          class="faq-item"
          v-for="(item, index) in m832Info.faqData"
          :key="index"
        >
          <div class="faq-title" @click="clickQuestion2(item, index)">
            <span v-text="item.title"></span>
            <img
              src="https://cdn.shopify.com/s/files/1/0595/1940/2172/files/f10e2c4832c0faf086185700b226c940.png?v=1646813187"
              class="downArrow"
              v-show="activeQuestion2.index === index"
            />
            <img
              src="https://cdn.shopify.com/s/files/1/0595/1940/2172/files/a016b412f93b877a827866a90379da25.png?v=1646813168"
              class="downArrow"
              v-show="activeQuestion2.index !== index"
            />
          </div>
          <div class="faq-scroll-area">
            <div
              class="faq-content"
              v-show="activeQuestion2.index === index"
              v-for="(child, y) in item.details"
              :key="index + '-' + y"
            >
              <div
                class="content-title"
                style="color: rgb(44, 62, 80)"
                v-text="child.theme"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <hr
      style="color: rgba(51, 61, 71, 0.3); width: 54%; margin-top: 30px"
      v-show="!isMobile()"
    />
    <hr
      style="color: rgba(51, 61, 71, 0.3); width: 100%; margin-top: 30px"
      v-show="isMobile()"
    />
    <div class="customService">
      <h1>Customer Service</h1>
      <div class="everyRow">
        Email：<a
          href="mailto:support@phomemo.com"
          @click="
            () => {
              refreshRecord({ key: 'M832_email' });
            }
          "
          >support@phomemo.com</a
        >
      </div>
      <div class="everyRow">Tel：+1 855 957 5321(US ONLY)</div>
      <div class="everyRow">Whatsapp：+44 7355 725440</div>
    </div>
  </div>
</template>

<script>
import { refreshRecord } from "@/util.js";
import { m832Info } from "./dataConfig.js";

const isMobile = () => {
  // 返回true为移动端，否则为pc端
  if (!window.navigator) return true;
  const flag = window.navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag ? true : false;
};
export default {
  name: "M832",
  props: {},
  data() {
    return {
      m832Info,
      activeQuestion2: {},
      isMobile,
      refreshRecord,
      window,
    };
  },
  mounted() {
    this.listenVideo("M832_macVideo");
    this.listenVideo("M832_windowsVideo");
    this.listenVideo("M832_linuxVideo");
    this.listenVideo("M832_APPVideo");
    this.listenVideo("M832_APPVideo_2");
  },
  methods: {
    listenVideo(videoId) {
      document.getElementById(videoId).addEventListener("play", function () {
        // console.log("视频开始播放了！");
        refreshRecord({
          key: videoId === "M832_APPVideo_2" ? "M832_APPVideo" : videoId,
        });
      });
    },
    clickQuestion2(item = {}, index) {
      const { activeQuestion2 } = this;
      if (
        activeQuestion2.index === undefined ||
        activeQuestion2.index !== index
      ) {
        this.activeQuestion2 = { ...item, index };
      } else this.activeQuestion2 = {};
    },
  },
};
</script>

<style lang="less" src="./style.less" />



// WEBPACK FOOTER //
// src/view/guides/m832.vue